import { render } from "./NotificationToolTip.vue?vue&type=template&id=af494a50&scoped=true"
import script from "./NotificationToolTip.vue?vue&type=script&lang=js"
export * from "./NotificationToolTip.vue?vue&type=script&lang=js"

import "./NotificationToolTip.vue?vue&type=style&index=0&id=af494a50&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af494a50"]])

export default __exports__